/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CalendarOAuthRedirectPathParams, CalendarOAuthRedirectResponse } from '../types/CalendarOAuthRedirect'

/**
 * GET /calendar-integrations/oauth/:provider/redirect
 * @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarOAuthController.php CalendarOAuthController::redirect
 */
export async function calendarOAuthRedirect(
	provider: CalendarOAuthRedirectPathParams['provider'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CalendarOAuthRedirectResponse>> {
	return axiosInstance.get(`/calendar-integrations/oauth/${provider}/redirect`, config)
}
